const SelectBranch = ({ branchList, selectBranch, storeId, color }) => {
  console.log(storeId);
  const handleChange = (e) => {
    selectBranch(e.target.value);
  };

  return (
    <select
      className={`w-full font-medium bg-white select border-${color}`}
      onChange={handleChange}
      value={storeId}
    >
      {branchList?.length > 0 ? (
        branchList.map((item, index) => (
          <option key={index} defaultValue={index === 0} value={item.id}>
            {item.name}
          </option>
        ))
      ) : (
        <option></option>
      )}
    </select>
  );
};

export default SelectBranch;
